<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1080 1920"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="fill-rule: evenodd; clip-rule: evenodd; stroke-miterlimit: 10"
  >
    <g id="Layer-1" serif:id="Layer 1" transform="matrix(0.5,0,0,0.5,0,0)">
      <g id="background">
        <g transform="matrix(2,-0,-0,2,0,0)">
          <image
            href="../assets/background.jpg"
            x="0"
            y="1"
            width="1080px"
            height="1919px"
          />
          <g class="golven2">
            <image
              id="golven-2.png"
              href="../assets/golven-2.png"
              x="0"
              y="0"
              width="1080px"
              height="1920px"
            />
          </g>
          <g class="golven1">
            <image
              id="golven-1.png"
              href="../assets/golven-1.png"
              x="0"
              y="0"
              width="1080px"
              height="1920px"
            />
          </g>
        </g>
      </g>
      <g id="scorebackground">
        <g transform="matrix(1,0,0,1,1177.13,197)">
          <path
            d="M0,384L-734.119,384C-744.383,384 -752.703,375.679 -752.703,365.415L-752.703,18.585C-752.703,8.321 -744.383,0 -734.119,0L0,0C10.264,0 18.585,8.321 18.585,18.585L18.585,365.415C18.585,375.679 10.264,384 0,384"
            style="fill: rgb(29, 29, 29); fill-rule: nonzero"
          />
        </g>
        <g transform="matrix(1,0,0,1,4.43115,1.13576e-13)">
          <g transform="matrix(2,-0,-0,2,-4.43115,-1.13576e-13)">
            <use
              xlink:href="#_Image2"
              x="212"
              y="98"
              width="386px"
              height="193px"
            />
          </g>
        </g>
        <g transform="matrix(1,0,0,1,4.43115,1.13576e-13)">
          <g opacity="0.13">
            <g transform="matrix(1,0,0,1,441.506,197)">
              <path
                d="M0,384C-11.878,384 -21.507,375.973 -21.507,366.071L-21.507,17.929C-21.507,8.027 -11.878,0 0,0L728.275,0C740.153,0 749.782,8.027 749.782,17.929L0,384Z"
                style="fill: rgb(173, 171, 173); fill-rule: nonzero"
              />
            </g>
          </g>
        </g>
        <g transform="matrix(1,0,0,1,4.43115,1.13576e-13)">
          <g transform="matrix(2,-0,-0,2,-4.43115,-1.13576e-13)">
            <use
              xlink:href="#_Image3"
              x="206.216"
              y="92.5"
              width="402px"
              height="209px"
            />
          </g>
        </g>
        <g transform="matrix(1,0,0,1,1177.13,197)">
          <path
            d="M0,384L-734.119,384C-744.383,384 -752.703,375.679 -752.703,365.415L-752.703,18.585C-752.703,8.321 -744.383,0 -734.119,0L0,0C10.264,0 18.585,8.321 18.585,18.585L18.585,365.415C18.585,375.679 10.264,384 0,384Z"
            style="
              fill: none;
              fill-rule: nonzero;
              stroke: rgb(103, 104, 104);
              stroke-width: 8px;
            "
          />
        </g>
      </g>
      <g id="timebackground">
        <g transform="matrix(1,0,0,1,2007.13,197)">
          <path
            d="M0,384L-734.119,384C-744.383,384 -752.703,375.679 -752.703,365.415L-752.703,18.585C-752.703,8.321 -744.383,0 -734.119,0L0,0C10.264,0 18.585,8.321 18.585,18.585L18.585,365.415C18.585,375.679 10.264,384 0,384"
            style="fill: rgb(29, 29, 29); fill-rule: nonzero"
          />
        </g>
        <g transform="matrix(1,0,0,1,4.43115,1.13576e-13)">
          <g transform="matrix(2,-0,-0,2,-4.43115,-1.13576e-13)">
            <use
              xlink:href="#_Image4"
              x="627"
              y="98"
              width="386px"
              height="193px"
            />
          </g>
        </g>
        <g transform="matrix(1,0,0,1,4.43115,1.13576e-13)">
          <g opacity="0.13">
            <g transform="matrix(1,0,0,1,1271.51,197)">
              <path
                d="M0,384C-11.878,384 -21.506,375.973 -21.506,366.071L-21.506,17.929C-21.506,8.027 -11.878,0 0,0L728.275,0C740.153,0 749.782,8.027 749.782,17.929L0,384Z"
                style="fill: rgb(173, 171, 173); fill-rule: nonzero"
              />
            </g>
          </g>
        </g>
        <g transform="matrix(1,0,0,1,4.43115,1.13576e-13)">
          <g transform="matrix(2,-0,-0,2,-4.43115,-1.13576e-13)">
            <use
              xlink:href="#_Image5"
              x="621.216"
              y="92.5"
              width="402px"
              height="209px"
            />
          </g>
        </g>
        <g transform="matrix(1,0,0,1,2007.13,197)">
          <path
            d="M0,384L-734.119,384C-744.383,384 -752.703,375.679 -752.703,365.415L-752.703,18.585C-752.703,8.321 -744.383,0 -734.119,0L0,0C10.264,0 18.585,8.321 18.585,18.585L18.585,365.415C18.585,375.679 10.264,384 0,384Z"
            style="
              fill: none;
              fill-rule: nonzero;
              stroke: rgb(103, 104, 104);
              stroke-width: 8px;
            "
          />
        </g>
      </g>
      <g id="score" transform="matrix(2,0,0,2,-508.247,-320.562)">
        <g transform="matrix(116.5,0,0,116.5,803.264,396.789)"></g>
        <text
          x="800px"
          y="396.789px"
          style="
            font-family: 'Helvetica';
            font-size: 116.5px;
            fill: rgb(149, 199, 0);
          "
          text-anchor="end"
        >
          {{ score }}
        </text>
      </g>
      <g id="time" transform="matrix(2,0,0,2,303.288,-320.562)">
        <g transform="matrix(116.5,0,0,116.5,817.57,396.789)"></g>
        <text
          x="526.088px"
          y="396.789px"
          style="
            font-family: 'Helvetica';
            font-size: 116.5px;
            fill: rgb(149, 199, 0);
          "
        >
          00:{{ timeLeftFormatted }}
        </text>
      </g>
      <g id="Battery" transform="matrix(250.42,0,0,-250.42,109.57,365)">
        <path
          d="M0.936,0.695L0.724,0.695C0.725,0.7 0.725,0.705 0.725,0.711L0.725,0.79C0.725,0.83 0.697,0.863 0.661,0.863L0.335,0.863C0.299,0.863 0.271,0.83 0.271,0.79L0.271,0.711C0.271,0.705 0.271,0.7 0.272,0.695L0.064,0.695C0.029,0.695 -0,0.663 -0,0.622L-0,-0.79C-0,-0.83 0.029,-0.863 0.064,-0.863L0.936,-0.863C0.971,-0.863 1,-0.83 1,-0.79L1,0.622C1,0.663 0.971,0.695 0.936,0.695Z"
          style="fill: rgb(78, 78, 78); fill-rule: nonzero"
        />
      </g>
      <g
        id="batteryConcealer"
        transform="matrix(204,4.74341e-16,-3.50747e-15,-1479.82,132.78,384.825)"
      >
        <g id="BatteryBar1" serif:id="BatteryBar">
          <!-- Bind height and y-position to computed properties for correct fill direction -->
          <rect
            x="0"
            y="-0.112"
            width="1"
            :height="batteryHeight"
            style="fill: rgb(158, 208, 0)"
          />
        </g>
      </g>
      <g transform="matrix(1.94659,0,0,9.51531,-49.7731,-194.693)">
        <rect
          x="117.39"
          y="36.12"
          width="56.954"
          height="45.401"
          style="fill: url(#_Linear6)"
        />
      </g>
      <g id="Fields" transform="matrix(1,0,0,1,-2.5,18.688)">
        <g opacity="0.5">
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
        </g>
      </g>
      <g :transform="posFieldTransform()">
        <g
          v-if="gameActive"
          @click="posFieldClicked"
          id="posField"
          transform="matrix(0.98485,0,0,0.983607,-617.24,-403.913)"
        >
          <g transform="matrix(-1,0,0,1,1822.12,-1168.38)">
            <rect
              x="758.754"
              y="2290.69"
              width="304.615"
              height="427"
              style="fill: rgb(149, 199, 0)"
            />
          </g>
          <g transform="matrix(1,0,0,1,895.564,1410.01)">
            <path
              d="M0,36.87C-2.547,36.87 -4.609,34.808 -4.609,32.261L-4.609,4.609C-4.609,2.061 -2.547,0 0,0C2.547,0 4.609,2.061 4.609,4.609L4.609,32.261C4.609,34.808 2.547,36.87 0,36.87"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,923.217,1345.48)">
            <path
              d="M0,101.392C-2.547,101.392 -4.609,99.33 -4.609,96.783L-4.609,18.435C-4.609,13.353 -8.745,9.217 -13.826,9.217C-16.374,9.217 -18.435,7.156 -18.435,4.609C-18.435,2.061 -16.374,0 -13.826,0C-3.659,0 4.609,8.268 4.609,18.435L4.609,96.783C4.609,99.33 2.547,101.392 0,101.392"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,909.391,1345.48)">
            <path
              d="M0,-36.87C-10.167,-36.87 -18.435,-28.602 -18.435,-18.435C-18.435,-8.268 -10.167,0 0,0C10.167,0 18.435,-8.268 18.435,-18.435C18.435,-28.602 10.167,-36.87 0,-36.87M0,9.217C-15.248,9.217 -27.652,-3.187 -27.652,-18.435C-27.652,-33.683 -15.248,-46.087 0,-46.087C15.248,-46.087 27.652,-33.683 27.652,-18.435C27.652,-3.187 15.248,9.217 0,9.217"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,892.202,1229.36)">
            <path
              d="M0,87.08C-0.558,87.08 -1.125,86.981 -1.679,86.765L-16.324,81.044C-23.26,78.33 -28.48,72.403 -30.29,65.179L-44.273,9.312C-44.773,7.314 -43.891,5.226 -42.104,4.199L-37.225,1.386C-35.34,0.297 -33.143,0 -31.014,0.567C-28.899,1.13 -27.13,2.489 -26.037,4.384L13.934,73.614C15.208,75.819 14.452,78.637 12.246,79.91C10.041,81.179 7.224,80.428 5.95,78.223L-33.508,9.879L-34.489,10.446L-21.351,62.938C-20.267,67.272 -17.13,70.832 -12.966,72.457L1.679,78.177C4.046,79.105 5.221,81.778 4.294,84.15C3.583,85.968 1.841,87.08 0,87.08"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,860.378,1338.95)">
            <path
              d="M0,86.81C-0.792,86.81 -1.589,86.608 -2.304,86.194L-7.179,83.376C-9.073,82.282 -10.428,80.514 -10.995,78.403C-11.567,76.288 -11.274,74.078 -10.181,72.183L29.786,2.962C31.059,0.752 33.877,0 36.082,1.274C38.288,2.548 39.044,5.365 37.77,7.57L-1.683,75.905L-0.707,76.472L38.184,38.841C41.398,35.736 42.91,31.244 42.239,26.825L39.885,11.374C39.503,8.858 41.231,6.508 43.747,6.126C46.281,5.73 48.612,7.472 48.995,9.987L51.349,25.438C52.474,32.797 49.949,40.286 44.593,45.466L3.204,85.514C2.322,86.369 1.166,86.81 0,86.81"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,1011.8,1300.14)">
            <path
              d="M0,36.123L-79.838,36.123C-82.385,36.123 -84.447,34.062 -84.447,31.514C-84.447,28.967 -82.385,26.906 -79.838,26.906L-1.022,26.906L-1.022,25.771L-53.05,10.91C-57.344,9.668 -62.002,10.613 -65.485,13.404L-77.772,23.238C-79.766,24.826 -82.66,24.502 -84.253,22.518C-85.842,20.528 -85.518,17.63 -83.533,16.036L-71.246,6.207C-65.431,1.553 -57.681,0 -50.516,2.044L4.852,17.864C6.832,18.431 8.196,20.24 8.196,22.297L8.196,27.927C8.196,32.446 4.519,36.123 0,36.123"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,955.469,1451.06)">
            <path
              d="M0,23.467C-8.488,23.467 -16.522,19.592 -23.039,12.436C-29.543,19.578 -37.594,23.467 -46.083,23.467C-54.567,23.467 -62.609,19.583 -69.122,12.436C-75.738,19.704 -83.826,23.674 -92.571,23.462C-102.679,23.314 -112.068,17.697 -119.003,7.651C-120.448,5.554 -119.921,2.683 -117.829,1.238C-115.731,-0.207 -112.864,0.32 -111.415,2.413C-106.221,9.942 -99.479,14.142 -92.436,14.245C-92.346,14.249 -92.256,14.249 -92.17,14.249C-85.342,14.249 -78.749,10.383 -73.573,3.335C-71.48,0.495 -66.755,0.513 -64.68,3.326C-59.508,10.37 -52.901,14.249 -46.083,14.249C-39.26,14.249 -32.653,10.37 -27.486,3.335C-25.393,0.495 -20.667,0.513 -18.592,3.326C-13.412,10.383 -6.819,14.249 0.009,14.249C0.095,14.249 0.185,14.249 0.27,14.245C7.318,14.146 14.065,9.942 19.259,2.413C20.708,0.311 23.575,-0.207 25.672,1.238C27.765,2.687 28.292,5.554 26.847,7.651C19.907,17.702 10.518,23.314 0.405,23.462C0.27,23.467 0.135,23.467 0,23.467"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,950.869,1374.79)">
            <path
              d="M0,54.337C-1.791,54.337 -3.502,53.284 -4.244,51.524C-5.234,49.184 -4.141,46.479 -1.796,45.484C18.619,36.838 35.259,22.134 46.326,2.961C47.6,0.756 50.417,0 52.622,1.274C54.828,2.547 55.584,5.365 54.31,7.57C42.235,28.494 24.074,44.539 1.796,53.972C1.211,54.22 0.603,54.337 0,54.337"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,958.462,1253.31)">
            <path
              d="M0,29.763C-1.188,29.763 -2.376,29.304 -3.276,28.395C-15.5,16.027 -31.761,9.217 -49.071,9.217C-51.619,9.217 -53.68,7.156 -53.68,4.609C-53.68,2.061 -51.619,0 -49.071,0C-29.282,0 -10.689,7.782 3.277,21.914C5.068,23.723 5.05,26.644 3.241,28.431C2.34,29.322 1.17,29.763 0,29.763"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,1009.34,1216.44)">
            <path
              d="M0,80.122C-1.904,80.122 -3.682,78.938 -4.348,77.039C-18.592,36.474 -57.01,9.218 -99.952,9.218C-102.499,9.218 -104.56,7.156 -104.56,4.609C-104.56,2.062 -102.499,0 -99.952,0C-53.104,0 -11.189,29.732 4.348,73.987C5.194,76.386 3.929,79.019 1.526,79.861C1.022,80.041 0.509,80.122 0,80.122"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,817.585,1252.9)">
            <path
              d="M0,131.758C-1.593,131.758 -3.141,130.935 -3.997,129.454C-27.418,88.889 -22.63,37.725 7.917,2.147C9.587,0.211 12.494,0 14.416,1.652C16.347,3.308 16.567,6.22 14.911,8.151C-13.093,40.767 -17.481,87.66 3.988,124.845C5.261,127.05 4.505,129.868 2.3,131.142C1.575,131.56 0.783,131.758 0,131.758"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,849.536,1303.76)">
            <path
              d="M0,62.461C-1.593,62.461 -3.141,61.637 -3.997,60.157C-13.894,43.023 -16.45,23.03 -11.198,3.871C-10.527,1.413 -7.98,0 -5.531,0.644C-3.078,1.319 -1.634,3.853 -2.304,6.31C-6.904,23.075 -4.667,40.561 3.988,55.548C5.261,57.753 4.505,60.571 2.3,61.844C1.575,62.263 0.783,62.461 0,62.461"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
        </g>
      </g>
      <g :transform="negFieldTransform()">
        <g
          v-if="gameActive"
          @click="negFieldClicked"
          id="negField"
          transform="matrix(0.98485,0,0,0.983607,-1256.5,-1725.88)"
        >
          <g transform="matrix(-1,0,0,1,3120.31,1519.62)">
            <rect
              x="1407.85"
              y="946.688"
              width="304.615"
              height="427"
              style="fill: rgb(0, 192, 212)"
            />
          </g>
          <g transform="matrix(1,0,0,1,1538.94,2758.86)">
            <path
              d="M0,-154.562L0.01,-154.562L0,-154.562ZM7.62,24.795L31.826,24.795L36.162,-0.627C36.394,-1.985 37.401,-3.082 38.735,-3.427C45.75,-5.244 52.449,-8.03 58.646,-11.708C59.841,-12.419 61.34,-12.354 62.473,-11.543L83.363,3.438L100.451,-13.656L85.46,-34.535C84.647,-35.666 84.583,-37.17 85.296,-38.367C89.01,-44.603 91.812,-51.361 93.622,-58.452C93.967,-59.798 95.075,-60.814 96.446,-61.04L121.79,-65.2L121.79,-89.372L96.444,-93.548C95.07,-93.774 93.962,-94.793 93.62,-96.143C91.865,-103.087 89.096,-109.793 85.39,-116.075C84.688,-117.263 84.751,-118.752 85.55,-119.877L100.463,-140.907L83.353,-158.018L62.317,-143.098C61.192,-142.297 59.698,-142.239 58.511,-142.94C52.288,-146.623 45.578,-149.398 38.567,-151.191C37.222,-151.535 36.207,-152.642 35.981,-154.013L31.81,-179.357L7.636,-179.357L3.453,-153.993C3.227,-152.621 2.21,-151.512 0.861,-151.169C-6.116,-149.397 -12.818,-146.628 -19.058,-142.94C-20.246,-142.236 -21.737,-142.299 -22.864,-143.098L-43.895,-158.019L-61.016,-140.913L-46.102,-119.877C-45.303,-118.75 -45.241,-117.26 -45.944,-116.072C-49.602,-109.887 -52.358,-103.234 -54.138,-96.296C-54.481,-94.958 -55.579,-93.948 -56.94,-93.716L-82.362,-89.388L-82.362,-65.181L-56.94,-60.852C-55.579,-60.621 -54.48,-59.609 -54.138,-58.271C-52.344,-51.271 -49.563,-44.581 -45.874,-38.385C-45.162,-37.19 -45.226,-35.687 -46.035,-34.556L-61.006,-13.659L-43.904,3.438L-23.025,-11.542C-21.896,-12.353 -20.396,-12.419 -19.198,-11.708C-13.001,-8.029 -6.303,-5.248 0.708,-3.441C2.044,-3.096 3.054,-2 3.285,-0.639L7.62,24.795ZM34.78,31.795L4.666,31.795C2.96,31.795 1.502,30.565 1.216,28.883L-3.24,2.739C-9.355,0.984 -15.236,-1.458 -20.776,-4.541L-42.238,10.857C-43.629,11.856 -45.54,11.7 -46.753,10.489L-68.055,-10.807C-69.266,-12.018 -69.423,-13.928 -68.426,-15.321L-53.039,-36.799C-56.132,-42.339 -58.574,-48.217 -60.32,-54.327L-86.45,-58.777C-88.132,-59.063 -89.362,-60.521 -89.362,-62.227L-89.362,-92.342C-89.362,-94.048 -88.132,-95.506 -86.45,-95.792L-60.32,-100.242C-58.587,-106.295 -56.168,-112.134 -53.105,-117.653L-68.436,-139.275C-69.423,-140.667 -69.262,-142.569 -68.054,-143.775L-46.752,-165.058C-45.546,-166.264 -43.644,-166.424 -42.253,-165.437L-20.638,-150.101C-15.068,-153.191 -9.183,-155.624 -3.087,-157.356L1.213,-183.426C1.491,-185.117 2.953,-186.357 4.666,-186.357L34.78,-186.357C36.494,-186.357 37.955,-185.117 38.233,-183.425L42.522,-157.372C48.641,-155.626 54.533,-153.188 60.093,-150.101L81.713,-165.437C83.105,-166.425 85.007,-166.265 86.213,-165.057L107.502,-143.767C108.709,-142.561 108.869,-140.66 107.882,-139.268L92.552,-117.651C95.654,-112.053 98.088,-106.164 99.81,-100.088L125.859,-95.795C127.55,-95.517 128.79,-94.055 128.79,-92.342L128.79,-62.227C128.79,-60.513 127.549,-59.051 125.857,-58.773L99.805,-54.497C98.042,-48.308 95.58,-42.369 92.462,-36.784L107.87,-15.324C108.87,-13.932 108.715,-12.02 107.503,-10.808L86.214,10.488C85.001,11.699 83.091,11.854 81.698,10.858L60.224,-4.541C54.686,-1.458 48.805,0.987 42.688,2.749L38.23,28.884C37.943,30.566 36.486,31.795 34.78,31.795"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1,0,0,1,1558.67,2647.21)">
            <path
              d="M0,68.693C-18.954,68.693 -34.375,53.293 -34.375,34.362C-34.375,32.414 -34.2,30.405 -33.856,28.39C-33.53,26.486 -31.733,25.202 -29.816,25.53C-27.911,25.856 -26.631,27.665 -26.956,29.57C-27.234,31.196 -27.375,32.808 -27.375,34.362C-27.375,49.432 -15.095,61.693 0,61.693C15.074,61.693 27.338,49.432 27.338,34.362C27.338,19.274 15.074,7 0,7C-1.645,7.005 -3.333,7.161 -5.007,7.464C-6.916,7.804 -8.73,6.544 -9.074,4.642C-9.418,2.74 -8.154,0.919 -6.253,0.575C-4.176,0.2 -2.075,0.005 -0.011,0C18.934,0 34.338,15.415 34.338,34.362C34.338,53.293 18.934,68.693 0,68.693"
              style="fill: white; fill-rule: nonzero"
            />
          </g>
        </g>
      </g>
      <g id="StartModal" v-if="!gameActive">
        <g transform="matrix(2,0,0,2,-9720,0)">
          <rect
            x="4860"
            y="0"
            width="1080"
            height="1920"
            style="fill-opacity: 0.5"
          />
        </g>
        <g
          id="StartBtn"
          transform="matrix(1.00072,0,0,1.00072,0.56421,-877.615)"
          @click="startGame()"
        >
          <g transform="matrix(1,0,0,1,1969.42,2536.78)">
            <path
              d="M0,258.817L-1781.54,258.817C-1790.78,258.817 -1798.27,251.326 -1798.27,242.085L-1798.27,16.733C-1798.27,7.492 -1790.78,0 -1781.54,0L0,0C9.241,0 16.732,7.492 16.732,16.733L16.732,242.085C16.732,251.326 9.241,258.817 0,258.817"
              style="fill: rgb(149, 199, 0); fill-rule: nonzero"
            />
          </g>
          <g transform="matrix(1.00052,0,0,1.00052,-409.118,-1.36457)">
            <g transform="matrix(129.135,0,0,129.135,1847.61,2712.17)"></g>
            <text
              x="1126.39px"
              y="2712.17px"
              style="
                font-family: 'HelveticaNeue-Bold', 'Helvetica Neue';
                font-weight: 700;
                font-size: 129.135px;
                fill: rgb(48, 48, 48);
              "
            >
              Start Game!
            </text>
          </g>
        </g>
      </g>
    </g>
    <g id="Layer-2" serif:id="Layer 2"></g>
    <defs>
      <image
        id="_Image2"
        width="386px"
        height="193px"
        xlink:href="data:image/png;base64,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"
      />
      <image
        id="_Image3"
        width="402px"
        height="209px"
        xlink:href="data:image/png;base64,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"
      />
      <image
        id="_Image4"
        width="386px"
        height="193px"
        xlink:href="data:image/png;base64,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"
      />
      <image
        id="_Image5"
        width="402px"
        height="209px"
        xlink:href="data:image/png;base64,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"
      />
      <linearGradient
        id="_Linear6"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(56.9544,0,0,45.4005,117.39,58.8203)"
      >
        <stop offset="0" style="stop-color: white; stop-opacity: 0" />
        <stop offset="0.5" style="stop-color: white; stop-opacity: 0.3" />
        <stop offset="1" style="stop-color: white; stop-opacity: 0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "GameScreen",
  data() {
    return {
      gameTime: 20, // Total time for the game
      gameTimeLeft: 20, // Countdown time in seconds
      score: 0,
      posActiveField: 0,
      negActiveField: 0,
      isRunning: false, // Track if the timer is running
      timer: null, // Reference to the interval timer
      posFieldTimer: null, // Timer for the posField countdown
      posFieldTime: 100, // Countdown time for positive field in milliseconds
      gameActive: false,
      fieldsRange: 36,
      fieldArray: [
        { x: 0, y: 0 },
        { x: 160, y: 0 },
        { x: 320, y: 0 },
        { x: 480, y: 0 },
        { x: 640, y: 0 },
        { x: 800, y: 0 },
        { x: 0, y: 220 },
        { x: 160, y: 220 },
        { x: 320, y: 220 },
        { x: 480, y: 220 },
        { x: 640, y: 220 },
        { x: 800, y: 220 },
        { x: 0, y: 440 },
        { x: 160, y: 440 },
        { x: 320, y: 440 },
        { x: 480, y: 440 },
        { x: 640, y: 440 },
        { x: 800, y: 440 },
        { x: 0, y: 660 },
        { x: 160, y: 660 },
        { x: 320, y: 660 },
        { x: 480, y: 660 },
        { x: 640, y: 660 },
        { x: 800, y: 660 },
        { x: 0, y: 880 },
        { x: 160, y: 880 },
        { x: 320, y: 880 },
        { x: 480, y: 880 },
        { x: 640, y: 880 },
        { x: 800, y: 880 },
        { x: 0, y: 1100 },
        { x: 160, y: 1100 },
        { x: 320, y: 1100 },
        { x: 480, y: 1100 },
        { x: 640, y: 1100 },
        { x: 800, y: 1100 },
      ],
    };
  },
  created() {
    this.assignActiveFields();
  },
  computed: {
    timeLeftFormatted() {
      return this.gameTimeLeft.toString().padStart(2, "0");
    },
    batteryHeight() {
      const maxHeight = 0.223; // Maximum height at 100%
      return (this.score / 750) * maxHeight;
    },
    yPosition() {
      const maxHeight = 0.223;
      return -0.112 + (maxHeight - this.batteryHeight);
    },
  },
  methods: {
    startGame() {
      this.assignActiveFields();
      this.startTimer();
      this.gameActive = true;
    },
    posFieldClicked() {
      if (this.gameActive) {
        console.log(this.posFieldTime);
        this.score += Math.round(this.posFieldTime / 2); // Add remaining posFieldTime to score
        this.score += 2; // Base score for positive field click
        // this.score += this.posFieldTime;
        this.resetPosFieldTimer(); // Reset the positive field timer
        this.assignActiveFields();
      }
    },
    negFieldClicked() {
      if (this.gameActive) {
        this.score -= 1;
        this.assignActiveFields();
      }
    },
    negFieldTransform() {
      const { x, y } = this.fieldArray[this.negActiveField - 1];
      return `translate(${x * 2}, ${y * 2})`;
    },
    posFieldTransform() {
      const { x, y } = this.fieldArray[this.posActiveField - 1];
      return `translate(${x * 2}, ${y * 2})`;
    },
    assignActiveFields() {
      this.posActiveField = this.getRandomNumber(
        this.fieldsRange,
        this.posActiveField,
        this.negActiveField
      );

      this.negActiveField = this.getRandomNumber(
        this.fieldsRange,
        this.posActiveField,
        this.negActiveField
      );

      this.resetPosFieldTimer(); // Reset the timer whenever a new posField is assigned
    },
    getRandomNumber(range, ...exclusions) {
      let randomNum;
      do {
        randomNum = Math.floor(Math.random() * range) + 1;
      } while (exclusions.includes(randomNum));
      return randomNum;
    },
    resetPosFieldTimer() {
      clearInterval(this.posFieldTimer); // Clear the old timer
      this.posFieldTime = 200; // Reset to 100 milliseconds
      // console.log("Timer reset to:", this.posFieldTime); // Log reset time
      this.posFieldTimer = setInterval(() => {
        if (this.posFieldTime > 0) {
          this.posFieldTime--;
          // console.log("PosFieldTime:", this.posFieldTime); // Log countdown
        } else {
          clearInterval(this.posFieldTimer); // Stop when it reaches 0
        }
      }, 1);
    },
    startTimer() {
      if (this.isRunning) return;
      this.isRunning = true;
      this.timer = setInterval(() => {
        if (this.gameTimeLeft > 0) {
          this.gameTimeLeft--;
        } else {
          this.endTimer();
        }
      }, 1000);
    },
    endTimer() {
      clearInterval(this.timer);
      clearInterval(this.posFieldTimer); // Stop the posField timer
      this.isRunning = false;
      this.onTimerEnd();
    },
    resetTimer() {
      clearInterval(this.timer);
      clearInterval(this.posFieldTimer); // Clear the posField timer
      this.isRunning = false;
      this.gameTimeLeft = this.gameTime;
    },
    onTimerEnd() {
      this.gameActive = false;
      this.$store.commit("setScore", this.score);
      this.$store.dispatch("updatePlayer");
      this.$store.commit("setPlayerState", "end");
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
    clearInterval(this.posFieldTimer); // Clean up posField timer
  },
};
</script>

<style></style>
